import "core-js/modules/es6.object.define-property";
import "core-js/modules/es6.object.is-extensible";
import "core-js/modules/es6.array.map";
import "core-js/modules/es6.array.filter";
import "core-js/modules/es6.array.find";
import "core-js/modules/es6.array.index-of";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.object.to-string";
import "core-js/modules/es6.object.keys";
import "core-js/modules/es6.object.assign";
import "core-js/modules/es6.object.assign";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.object.to-string";
import "core-js/modules/es6.object.keys";
import "core-js/modules/es6.object.is-extensible";
import "core-js/modules/es6.array.find";

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}
/** @jsx jsx */


import React from 'react';
import { jsx } from 'theme-ui';
import { Link } from 'gatsby';
import { useDocs, useCurrentDoc } from 'docz';
import { get } from 'lodash/fp';
import * as styles from './styles';
import { jsx as ___EmotionJSX } from "@emotion/core";

var getHeadings = function getHeadings(route, docs) {
  var doc = docs.find(function (doc) {
    return doc.route === route;
  });
  var headings = get('headings', doc);
  return headings ? headings.filter(function (heading) {
    return heading.depth === 2;
  }) : [];
};

var getCurrentHash = function getCurrentHash() {
  if (typeof window === 'undefined') {
    return '';
  }

  return window.location ? decodeURI(window.location.hash) : '';
};

export var NavLink = React.forwardRef(function (_ref, ref) {
  var item = _ref.item,
      props = _objectWithoutPropertiesLoose(_ref, ["item"]);

  var docs = useDocs();
  var to = item.route;
  var headings = docs && getHeadings(to, docs);
  var current = useCurrentDoc();
  var isCurrent = item.route === current.route;
  var showHeadings = isCurrent && headings && headings.length > 0;
  var currentHash = getCurrentHash();
  return jsx(React.Fragment, null, jsx(Link, _extends({}, props, {
    to: to,
    sx: styles.link,
    activeClassName: "active",
    ref: ref
  })), showHeadings && headings.map(function (heading) {
    return jsx(Link, {
      key: heading.slug,
      to: to + "#" + heading.slug,
      sx: styles.smallLink,
      className: currentHash === "#" + heading.slug ? 'active' : ''
    }, heading.value);
  }));
});

if (typeof NavLink !== 'undefined' && NavLink && NavLink === Object(NavLink) && Object.isExtensible(NavLink) && !NavLink.hasOwnProperty('__filemeta')) {
  Object.defineProperty(NavLink, '__filemeta', {
    configurable: true,
    value: {
      name: "NavLink",
      filename: "node_modules/gatsby-theme-docz/src/components/NavLink/index.js"
    }
  });
}